module.exports = __webpack_public_path__ + "img/logo.f5a9bb1a.png";